<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g id="launched-since">
      <path
        id="Vector"
        d="M7.375 16H4.75C4.33579 16 4 15.6642 4 15.25V5.5C4 5.08579 4.33579 4.75 4.75 4.75H15.25C15.6642 4.75 16 5.08579 16 5.5V7.375M7 4.75V3.25M13 4.75V3.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M13.75 17.5C15.8211 17.5 17.5 15.8211 17.5 13.75C17.5 11.6789 15.8211 10 13.75 10C11.6789 10 10 11.6789 10 13.75C10 15.8211 11.6789 17.5 13.75 17.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_3"
        d="M13.75 12.25V13.7498L14.875 14.875"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CalendarScheduleIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
